import axios from "@/axios";

export default {
    logout() {
        return axios.post('logout');
    },
    login(payload) {
        return axios.post('login', payload);
    },
    me(payload) {
        return axios.get('me', payload);
    },
    update(payload) {
        return axios.post('me', payload);
    },
    register: {
        create(payload) {
            return axios.post('register', payload);
        },
        verify(id, payload) {
            return axios.post(`register/${id}/verify`, payload);
        },
        password(id, payload) {
            return axios.post(`register/${id}/password`, payload);
        },
        code(id) {
            return axios.post(`register/${id}/code`);
        }
    },
    recovery: {
        create(payload) {
            return axios.post('recovery', payload);
        },
        verify(id, payload) {
            return axios.post(`recovery/${id}/verify`, payload);
        },
        password(id, payload) {
            return axios.post(`recovery/${id}/password`, payload);
        },
        code(id) {
            return axios.post(`recovery/${id}/code`);
        }
    },
}